import gql from 'graphql-tag';
import { createApolloClient } from './apollo';
export const QUERY = gql `
  query {
    services {
      id
      code
      name
    }
  }
`;
export async function fetchProjectService(project, getAccessToken) {
    const client = createApolloClient(project.apiUri, getAccessToken);
    const result = await client.query({
        query: QUERY,
    });
    return result.data.services;
}
export async function fetchAllProjectServices(projects, getAccessToken) {
    const allProjectsServices = await Promise.all(projects.map(async (project) => ({
        id: project.id,
        services: await fetchProjectService(project, getAccessToken),
    })));
    return allProjectsServices.reduce((acc, projectServices) => {
        acc[projectServices.id] = projectServices.services;
        return acc;
    }, {});
}
